import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Components
import MemberCardRedesign from '@molecules/MemberCardRedesign';
import { ButtonNoStyles, DivWithShadowAlternate, H4 } from '@styled';

// Functionality
import useAuthorized from '@hooks/useAuthorized';
import usePropertyContactAddRemove from '@hooks/usePropertyContactAddRemove';
import useViewer from '@hooks/useViewer';

const PropertyDetailContacts = ({ property, onContactAddRemove }) => {
    const [isViewerAPropertyContact, setIsViewerAPropertyContact] = useState(false);
    const { viewer } = useViewer();
    const { isLoggedIn } = useAuthorized();

    const {
        addViewerAsPropertyContact,
        removeViewerFromPropertyContacts,
        isLoading: isLoadingPropertyContactUpdate,
    } = usePropertyContactAddRemove({
        onCompleted: () => onContactAddRemove(),
    });

    useEffect(() => {
        if (!property?.contacts || !viewer) {
            return;
        }

        setIsViewerAPropertyContact(!!property.contacts.find(contact => contact.id === viewer.id));
    }, [property, viewer]);

    return (
        <div>
            <div className="d-md-flex justify-content-between">
                <H4>Additional Property Contacts</H4>

                {isLoggedIn && (
                    <div>
                        <ButtonNoStyles
                            disabled={isLoadingPropertyContactUpdate}
                            onClick={() => {
                                if (!isViewerAPropertyContact) {
                                    addViewerAsPropertyContact({ variables: { id: property.id } });
                                } else {
                                    removeViewerFromPropertyContacts({ variables: { id: property.id } });
                                }
                            }}
                        >
                            <span
                                className={classnames('accent', {
                                    'cursor-pointer': !isLoadingPropertyContactUpdate,
                                    'cursor-wait': isLoadingPropertyContactUpdate,
                                })}
                            >
                                {!isViewerAPropertyContact && <>Add yourself as a contact for this property</>}
                                {isViewerAPropertyContact && <>Remove yourself as a contact for this property</>}
                            </span>
                        </ButtonNoStyles>
                    </div>
                )}
            </div>

            <DivWithShadowAlternate className="mt-3 p-4">
                {property?.contacts.length > 0 && (
                    <div className="row">
                        {property.contacts.map(contact => (
                            <div className="col-md-6 mb-4" key={contact.id}>
                                <MemberCardRedesign
                                    businessType={[contact.company?.primaryBusinessType?.name]}
                                    companyName={contact.company?.name}
                                    designations=""
                                    displayLocation={`${contact.address?.city}, ${contact.address?.stateProvince}`}
                                    firstName={contact.firstName}
                                    fullName={`${contact.firstName} ${contact.lastName}`}
                                    graphID={contact.id}
                                    id={contact.recordId}
                                    lastName={contact.lastName}
                                    url={`/member/profile/${contact.recordId}`}
                                    photoURL={contact.photoUrl}
                                    title={contact.title}
                                />
                            </div>
                        ))}
                    </div>
                )}

                {property?.contacts.length === 0 && <H4>No additional contacts.</H4>}
            </DivWithShadowAlternate>
        </div>
    );
};

PropertyDetailContacts.propTypes = {
    property: PropTypes.shape({
        id: PropTypes.string.isRequired,
        contacts: PropTypes.arrayOf(
            PropTypes.shape({
                //
            })
        ),
    }).isRequired,
    onContactAddRemove: PropTypes.func,
};

export default PropertyDetailContacts;
